import React from 'react';
import { Heading2 } from '../Type';
import INFORMATION_ICONS from './modal-icons';
import { assert } from '../../utils';
export default function useModalTitle(title, headerIcon) {
    const renderIcon = () => {
        if (typeof headerIcon === 'string') {
            const Icon = INFORMATION_ICONS[headerIcon];
            assert(Icon, `No such modal icon ${headerIcon}: must be from ${Object.keys(INFORMATION_ICONS).join(', ')}`);
            return (React.createElement(Icon, { width: 64, height: 64, viewBox: '0 0 32 32', "data-testid": headerIcon }));
        }
        return headerIcon;
    };
    // for style reasons, even if no title is supplied, we need an empty div!
    return title ? (React.createElement(React.Fragment, null,
        headerIcon && renderIcon(),
        React.createElement(Heading2, { "data-testid": 'kal-modal-title', noTopSpacer: true }, title))) : (React.createElement("div", null));
}
//# sourceMappingURL=useModalTitle.js.map